import { render, staticRenderFns } from "./EditPage.vue?vue&type=template&id=af969f4a&scoped=true"
import script from "./EditPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EditPage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EditPage.vue?vue&type=style&index=0&id=af969f4a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af969f4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
